<template>
  <div class="navTop">
    <van-nav-bar
      :title="title"
      left-arrow
      :border="false"
      @click-left="onClickLeft"
      class="nav-bar"
      fixed
      placeholder 
    />
  </div>
</template>

<script>
export default {
  name: "navTop",
  props: {
    title: {
      type: String,
      default() {
        return this.$route.meta.name || '顶部导航';
      }
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    onClickLeft() {
      this.$router.back();
    },
  },
  components: {},
};
</script>

<style scoped lang="less">
.navTop {
    width: 100vw;
    border-bottom: 1px solid #e5e5e5;
  .nav-bar {
    background-color: #fff;
    /deep/ .van-nav-bar__title {
      color: #000;
      font-size: 16px;
    }
    /deep/ .van-icon {
      color: #000;
    }
  }
}
</style>
